import React, { useState } from "react";
import {
  Box,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Drawer,
  List,
  ListItemButton,
  ListItemText,
  Container,
  Stack,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import CallIcon from "@mui/icons-material/Call";

import { Link } from "react-router-dom";
import { useBooking } from "../context/BookingContext";

const PHONE_DISPLAY = "+91 81231 98675";
const PHONE_TEL = "+918123198675";

const navLinks = [
  { label: "Fleet", href: "/#fleet" },
  { label: "How it works", href: "/#how-it-works" },
  { label: "Why RideX", href: "/#why-choose-us" },
  { label: "Franchise / Invest", href: "/#franchise-invest" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { openBookingModal } = useBooking();

  return (
    <Box
      component="header"
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 100,
        bgcolor: "rgba(255, 255, 255, 0.94)",
        backdropFilter: "blur(14px)",
        borderBottom: "1px solid",
        borderColor: "divider",
        boxShadow: "0 4px 20px -10px rgba(0,0,0,0.06)",
      }}
    >
      {/* Top Accent Stripe - Lime Green */}
      <Box sx={{ height: "3px", bgcolor: "secondary.main" }} />

      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ py: 1.25, justifyContent: "space-between" }}>
          {/* Logo */}
          <Box
            component={Link}
            to="/"
            sx={{ display: "flex", alignItems: "center", textDecoration: "none" }}
          >
            <Box
              component="img"
              src="/assets/images/logo.png"
              alt="RideX City EV Rentals"
              sx={{ height: { xs: 36, md: 54 }, width: "auto", display: "block" }}
            />
          </Box>

          {/* Desktop Nav Links */}
          <Stack direction="row" spacing={3.5} alignItems="center" sx={{ display: { xs: "none", md: "flex" } }}>
            {navLinks.map((link) => (
              <Typography
                key={link.label}
                component="a"
                href={link.href}
                sx={{
                  fontSize: 14.5,
                  fontWeight: 600,
                  color: "text.primary",
                  textDecoration: "none",
                  transition: "color 0.2s ease",
                  "&:hover": { color: "primary.main" },
                }}
              >
                {link.label}
              </Typography>
            ))}

            <Box
              component="a"
              href={`tel:${PHONE_TEL}`}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                fontSize: 14,
                fontWeight: 600,
                color: "text.primary",
                textDecoration: "none",
                px: 1.75,
                py: 0.75,
                borderRadius: "8px",
                bgcolor: "background.default",
                border: "1px solid",
                borderColor: "divider",
                transition: "all 0.2s ease",
                "&:hover": {
                  borderColor: "primary.main",
                  color: "primary.main",
                },
              }}
            >
              <CallIcon sx={{ fontSize: 16, color: "primary.main" }} />
              {PHONE_DISPLAY}
            </Box>

            <Button
              variant="contained"
              onClick={() => openBookingModal("Blaze")}
              sx={{
                bgcolor: "primary.main",
                color: "primary.contrastText",
                px: 2.75,
                py: 1,
                borderRadius: "10px",
                fontSize: 14.5,
                fontWeight: 700,
                boxShadow: "0 4px 14px rgba(27, 78, 216, 0.25)",
                "&:hover": {
                  bgcolor: "primary.dark",
                  boxShadow: "0 6px 18px rgba(27, 78, 216, 0.35)",
                },
              }}
            >
              Book a Ride
            </Button>
          </Stack>

          {/* Mobile Hamburger Menu */}
          <IconButton
            onClick={() => setOpen(true)}
            sx={{ display: { xs: "flex", md: "none" }, color: "text.primary" }}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </Container>

      {/* Mobile Drawer */}
      <Drawer anchor="right" open={open} onClose={() => setOpen(false)}>
        <Box sx={{ width: 280, bgcolor: "background.paper", height: "100%", pt: 2 }}>
          <Box sx={{ display: "flex", justifyContent: "flex-end", px: 2 }}>
            <IconButton onClick={() => setOpen(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
          <List>
            {navLinks.map((link) => (
              <ListItemButton key={link.label} component="a" href={link.href} onClick={() => setOpen(false)}>
                <ListItemText
                  primary={link.label}
                  primaryTypographyProps={{ fontWeight: 600, fontSize: 15 }}
                />
              </ListItemButton>
            ))}
            <Box sx={{ px: 2, pt: 2 }}>
              <Button
                fullWidth
                variant="contained"
                onClick={() => {
                  setOpen(false);
                  openBookingModal("Blaze");
                }}
                sx={{
                  bgcolor: "primary.main",
                  color: "primary.contrastText",
                  borderRadius: "10px",
                  py: 1.25,
                  fontWeight: 700,
                  mb: 1.5,
                }}
              >
                Book a Ride
              </Button>
              <Button
                fullWidth
                variant="outlined"
                startIcon={<CallIcon sx={{ fontSize: 18 }} />}
                href={`tel:${PHONE_TEL}`}
                sx={{
                  borderRadius: "10px",
                  borderColor: "divider",
                  color: "text.primary",
                  fontWeight: 600,
                  py: 1.25,
                }}
              >
                {PHONE_DISPLAY}
              </Button>
            </Box>
          </List>
        </Box>
      </Drawer>
    </Box>
  );
}
